export default __webpack_public_path__ + "static/media/IconDesc_HazmatFilter.256.9a1c6e83.png";